import React, { useState, useEffect } from 'react';
import { Row, Col, Table, Stack } from 'react-bootstrap';
import { Link, useNavigate, useParams } from "react-router-dom";
import './CustmssmerReceipts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';
import { addressviewhtml } from '../../Utils/Common';


const CustmssmerReceipts = () => {
	const [loading, setLoading] = useState(true);
	const { order_id, id } = useParams();
	const navigate = useNavigate();

	const [inputs, setInputs] = useState({ store_name: '', store_address: '', store_zip: '', store_mobile: '', user_name: '', user_number: '', agree: 0, user_mobile: '', user_address_state: '', user_address_city: '', user_address_zip_code: '', due_date: '', order_number: '', date: '', employee_name: '', store_image: '', subtotal: '', saving_amount: 0, sales_tax_rate_per: 0, sales_tax_rate: 0, tips: '', total_due: '', payment_type: '', payment_txn_id: '', payment_card_number: '', user_address_street_name: '', status: 0, refund_price: 0, refund_discount: 0, refund_tax: 0, refund_total: 0, refund_date: '', store_discount: 0, store_street_name: '', store_area: '', store_city: '', store_state: '', store_country_id: '', user_address_apt_name: '', user_address_country_id: '' });
	const [orderrev, setOrderrev] = useState([]);

	const [coupon, setCoupon] = useState([]);

	useEffect(() => {
		document.title = `Custmss Receipts | Blue Faucet`;
		document.getElementById('bodywrap').className = 'usrrcptcpgmain grnbg';
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});

		let formData = new FormData();
		formData.append('token', localStorage.getItem("token"));
		formData.append('id', id);
		formData.append('order_id', order_id);
		API.post('backoffice_merchant_order_receipt', formData)
			.then(response => {
				if (response.data.status === 0) {
					setLoading(false);
					window.location.href = "/custmss-receipts/" + id;
				} else {
					setLoading(false);

					var sales_tax_rate_per = response.data.data.sales_tax_rate_per;
					var sales_tax_rate = response.data.data.sales_tax_rate;

					var saving_amount = 0;
					if (response.data.data.saving_amount !== '') {
						saving_amount = parseFloat(response.data.data.saving_amount);
					}
					var subtotal = parseFloat(response.data.data.subtotal);
					var total = subtotal - saving_amount;

					var store_discount = parseFloat(response.data.data.store_discount);

					var tips = parseFloat(response.data.data.tips);
					var total_due = total + tips + sales_tax_rate - store_discount;

					tips = tips.toFixed(2);
					saving_amount = saving_amount.toFixed(2);
					sales_tax_rate = sales_tax_rate.toFixed(2);
					subtotal = subtotal.toFixed(2);
					total = total.toFixed(2);
					total_due = total_due.toFixed(2);


					setInputs(
						{
							store_name: response.data.data.store_name,
							store_address: response.data.data.store_address,
							store_zip: response.data.data.store_zip,
							store_mobile: response.data.data.store_mobile,
							user_name: response.data.data.user_name,
							user_number: response.data.data.user_number,
							agree: response.data.data.agree,
							user_mobile: response.data.data.user_mobile,
							user_address_state: response.data.data.user_address_state,
							user_address_city: response.data.data.user_address_city,
							user_address_zip_code: response.data.data.user_address_zip_code,
							due_date: response.data.data.due_date,
							order_number: response.data.data.order_number,
							date: response.data.data.date,
							employee_name: response.data.data.employee_name,
							store_image: response.data.data.store_image,
							subtotal: subtotal,
							saving_amount: saving_amount,
							sales_tax_rate_per: sales_tax_rate_per,
							sales_tax_rate: sales_tax_rate,
							tips: tips,
							total_due: total_due,
							payment_type: response.data.data.payment_type,
							payment_txn_id: response.data.data.payment_txn_id,
							payment_card_number: response.data.data.payment_card_number,
							user_address_street_name: response.data.data.user_address_street_name,
							status: response.data.data.status,
							refund_price: response.data.data.refund_price,
							refund_discount: response.data.data.refund_discount,
							refund_tax: response.data.data.refund_tax,
							refund_total: response.data.data.refund_total,
							refund_date: response.data.data.refund_date,
							store_discount: store_discount,
							store_street_name: response.data.data.store_street_name,
							store_area: response.data.data.store_area,
							store_city: response.data.data.store_city,
							store_state: response.data.data.store_state,
							store_country_id: response.data.data.store_country_id,
							user_address_apt_name: response.data.data.user_address_apt_name,
							user_address_country_id: response.data.data.user_address_country_id
						}
					);

					var serv = response.data.data.order_array;
					//rec(serv)
					const tempArr = serv.map(item => ({ ...item, isSelected: false }))

					setOrderrev(tempArr);

					setCoupon(response.data.data.coupon);

				}
			}).catch(error => {
				setLoading(false);
			});

	}, [order_id, id]);


	return (<>
		<section className="d-flex justify-content-center">
			<div className='col-12 col-md-6 col-lg-5'>
				<header className="receipt-header rec-bg-green">
					<div className="col-md-1 col-1" onClick={() => navigate(-1)}>
						<Link to=''><svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none"><path d="M6.87756 0.514167C6.63045 0.637723 0.150184 7.12652 0.0607126 7.33955C-0.0202375 7.54406 -0.0202375 7.8849 0.0607126 8.08941C0.107578 8.20018 1.11306 9.23123 3.39671 11.5234C6.83496 14.9659 6.86904 15 7.23971 15C7.52516 15 7.72115 14.9148 7.92565 14.7018C8.22815 14.395 8.28354 14.0158 8.08755 13.6366C8.04495 13.5557 6.92869 12.4053 5.60366 11.0803L3.1922 8.6731L11.2744 8.6518L19.3609 8.63049L19.5526 8.52398C19.6549 8.46433 19.7998 8.33226 19.8722 8.23426C19.9872 8.06384 20 8.01698 20 7.71448C20 7.41198 19.9872 7.36511 19.8722 7.19469C19.7998 7.0967 19.6549 6.96462 19.5526 6.90498L19.3609 6.79846L11.2744 6.77716L3.1922 6.75586L5.62497 4.32735C7.26527 2.68704 8.08329 1.84346 8.13868 1.72842C8.34745 1.28533 8.15146 0.744236 7.69985 0.509907C7.48682 0.399133 7.10337 0.403393 6.87756 0.514167Z" fill="white"></path></svg></Link>
					</div>
					<div className="col-md-9 col-7">
						<h5>{
							inputs.status === 7
								? 'Refund Request'
								: inputs.status === 5
									? 'Refund Receipt'
									: (inputs.status === 1 || inputs.status === 8)
										? 'Receipts'
										: 'Order Details'
						}</h5>
					</div>
					<div className="col-md-1 col-2">
					</div>
				</header>
				<div className="jikam">
					<Row className="mx-0 mianhmdwncnt">
						<Col className="mnhmcnt p-0">
							<Col md={12} xs={12}>
								<Row className="mx-0 maincnt-recepts">
									<div className="mrrec-one">
										<div className="d-flex align-items-start justify-content-between gap-3">
											<div>
												<h3>{inputs.store_name}</h3>
												{addressviewhtml(inputs.store_street_name, inputs.store_area, inputs.store_city, inputs.store_state, inputs.store_zip, inputs.store_country_id)}
												<p>Phone: {inputs.store_mobile}</p>
											</div>
											<div className="text-end left-cnt-rcpt mrrec-two">
												<img src={inputs.store_image} className="img-fluid" alt="Hm Img" />
												{/* <h4>Due Date:<span>20May 2023</span></h4> */}
											</div>
										</div>
										<div className="left-cnt-rcptr">
											<h4>Customer Name: <span>{inputs.user_name}</span></h4>
											<h4>Customer ID #: <span>{inputs.user_number}</span></h4>
											{inputs.agree === 1 ?
												<h4>Contact No: <span>{inputs.user_mobile}</span></h4>
												: null}

											{inputs.user_address_street_name !== '' ?
												<>
													<h4>Customer address:</h4><span>{addressviewhtml(inputs.user_address_street_name, inputs.user_address_apt_name, inputs.user_address_city, inputs.user_address_state, inputs.user_address_zip_code, inputs.user_address_country_id)}</span>
												</>
												: null}

										</div>
										<div className="dwncmt">
											{/* <h4>Serviced by: <span>xxxxxxxxxxxx</span></h4> */}
											<h5>Information:</h5>
											<h4>{inputs.status === 1 || inputs.status === 5 || inputs.status === 8 ? 'Order Date & Time' : 'Schedule date & time'}: <span>{inputs.due_date}</span></h4>
											<h4>{inputs.status === 1 || inputs.status === 5 || inputs.status === 8 ? 'Receipt No' : 'Invoice No'}: <span>{inputs.order_number}</span></h4>
											<h4>{inputs.status === 1 || inputs.status === 5 || inputs.status === 8 ? 'Payment Date' : 'Invoice Date'}: <span>{inputs.date}</span></h4>
											{inputs.employee_name !== '' ?
												<h4>Employee Name: <span>{inputs.employee_name}</span></h4>
												: null}
										</div>
									</div>
									
									<Col md={12} xs={12} className="tblinvcpg mrrec-thr">
										<Table responsive>
											<thead>
												<tr>
													<th>#</th>
													<th>Service/Items</th>
													<th>Price</th>
													<th>Q’ty</th>
													<th>Amount</th>
												</tr>
											</thead>
											<tbody>
												{orderrev && orderrev.map((val, index) => {
													return (
														<tr className={val.status ? "textdecoration-line-through" : ""}>
															<td>{index + 1}</td>
															<td>{val.product_name}</td>
															<td>${val.product_price}</td>
															<td>1</td>
															<td>${val.total}</td>
														</tr>
													)
												})}
											</tbody>
										</Table>
										<Row>
											<Col sm={6} xs={12} className="py-2 mrrrileft">
												{(inputs.status === 7 || inputs.status === 5) && (
													<div className="text-left tbldwndv">
														<h3>Refund information </h3>
														<p><b>The Price after refund and discount: <span className="text-danger">${inputs.refund_price}</span></b></p>
														{/*<p>Coupon or Discount: <span className="text-danger">-${inputs.refund_discount}</span></p>*/}
														<p><b>The tax for the price: 	 <span className="text-danger">${inputs.refund_tax}</span></b></p>
														<p><b>Refund Total Amount: <span className="text-danger">${inputs.refund_total}</span></b></p>
														{inputs.status === 5 && (
															<p>
																<b>
																	Refund Date:
																	<span className="text-danger"> {inputs.refund_date}</span>
																</b>
															</p>
														)}
													</div>
												)}
											</Col>
											<Col sm={6} xs={12} className="py-2 mrrriright">
												<div className="text-end tbldwndv">
													<Stack direction="horizontal" gap={0}>
														<div className="pb-1 ms-auto">
															<p>Subtotal</p>
														</div>
														<div className="pb-1"><span>${inputs.subtotal}</span></div>
													</Stack>
													<Stack direction="horizontal" gap={0}>
														<div className="pb-1 ms-auto">
															<p>Coupon or discount</p>
														</div>
														<div className="pb-1"><span>${inputs.saving_amount}</span></div>
													</Stack>
													{inputs.store_discount > 0 && (<Stack direction="horizontal" gap={0}>
														<div className="pb-1 ms-auto">
															<p>Store Discount</p>
														</div>
														<div className="pb-1">-<span>${inputs.store_discount}</span></div>
													</Stack>)}
													<Stack direction="horizontal" gap={0}>
														<div className="pb-1 ms-auto">
															<p>Tax ({inputs.sales_tax_rate_per}%)</p>
														</div>
														<div className="pb-1"><span>${inputs.sales_tax_rate}</span></div>
													</Stack>
													<Stack direction="horizontal" gap={0}>
														<div className="pb-1 ms-auto">
															<p>Gratuity</p>
														</div>
														<div className="pb-1"><span>{inputs.tips}</span></div>
													</Stack>
													<Stack direction="horizontal" gap={4} className="lstprcdv">
														<div className=" ms-auto">
															<h6>{inputs.status === 1 || inputs.status === 5 ? 'Total Paid' : 'Total Due'}</h6>
														</div>
														<div className="">
															<h6>${inputs.total_due}</h6>
														</div>
													</Stack>
												</div>
											</Col>
										</Row>
									</Col>
									{(inputs.status === 1 || inputs.status === 5 || inputs.status === 8) && (
										<Col md={6} xs={7} className="dwn-cntrecpt mrrec-fou">
											<h3>Payment Information</h3>
											{inputs.payment_type === 'cash' ? (
												<>
													<p>Payment Type: {inputs.payment_type}</p>
												</>
											) : (
												<>
													<p>Payment Type: {inputs.payment_type}</p>
													<p>Transaction ID: {inputs.payment_txn_id}</p>
													{/*<p>Card Name: {inputs.payment_card_name}</p>*/}
													<p>Card: xxxx xxxx xxxx {inputs.payment_card_number}</p>
													{/*<p>Card Expiry: {inputs.payment_card_month} / {inputs.payment_card_year}</p>*/}
												</>
											)}
										</Col>
									)}
									{coupon.length > 0 && (
										<div className="mb-3 mt-3">
											<label className="form-label mb-4">Coupon</label>
											<Row>

												<Col md={12} xs={12}>
													<ul className="sldr-add">
														{coupon.length > 0 && coupon.map((item, index) => {
															return (<li className="sldr-in-add">
																<div className="row mincrd">
																	<Col md={12} xs={12} className="align-self-center mb-2">
																		<h4>{item.coupon_type}</h4>
																	</Col>

																	<Col md={12}>
																		{(() => {
																			if (item.coupon_type === 'Buy & Get') {
																				return (<p>Buy {item.buy_quantity} get {item.get_quantity} free,for {item.product_item_name}</p>)
																			} else if (item.coupon_type === 'Discount Offer') {
																				return (<p>{item.discount_percentage} % Discount When Purchase Over ${item.minimum_purchase_amount}</p>)
																			} else if (item.coupon_type === 'Loyalty Setup') {
																				return (<p>Buy {item.buy_quantity_needed} {item.product_applicable_item_if_any} get {item.product_get_item_name} free</p>)
																			} else if (item.coupon_type === 'Invitation') {
																				return (<p>{item.product_item_name}</p>)
																			} else if (item.coupon_type === 'Welcome coupon') {
																				return (<p>{item.discount_percentage}% for all new members joining your membership has been set up</p>)
																			}
																		})()}
																		{(() => {
																			if (item.coupon_type !== 'Welcome coupon') {
																				return (<p>{item.description}</p>)
																			}
																		})()}
																	</Col>
																</div>
															</li>
															)
														})}
													</ul>
												</Col>

											</Row>
										</div>
									)}



								</Row>
							</Col>
						</Col>
					</Row>
				</div>
			</div>
		</section>
		{loading && (
			<div className="loadingClass">
				<img src={loader} alt="loader" />
			</div>
		)}
	</>
	)
}
export default CustmssmerReceipts;